import React from 'react';
import classNames from 'classnames';
import styles from './PopupGenFreeAIResponse.module.scss';
import Popup, { Props as PopupProps } from '../Popup';
import PremiumBenefits, {
  TitleVersion,
} from '../PremiumBenefits/PremiumBenefits';
import { Phrases } from '../../../utilities/constants/phrases';
import LinearLoader, {
  Props as LinearLoaderProps,
} from '../../LinearLoader/LinearLoader';
import Rating from '../Rating/Rating';
import TooltipFreePlan, {
  Version as TooltipFreePlanVersion,
} from '../../Tooltip/TooltipFreePlan/TooltipFreePlan';
import { EditorPopupId } from '../../../utilities/constants/popup-type';

const POPUP_ID = EditorPopupId.GEN_FREE_AI_RESPONSE;
const GENERATION_DURATION = 5000;

interface Props
  extends Pick<PopupProps, 'isOpen' | 'onClose'>,
    Pick<LinearLoaderProps, 'isLoading'> {}

const PopupGenFreeAIResponse: React.FC<Props> = ({
  isOpen,
  isLoading = false,
  onClose,
}) => (
  <Popup
    isOpen={isOpen}
    id={POPUP_ID}
    size='lg'
    role='alertdialog'
    dialogClassName={styles.popupGenFreeAIResponse}>
    <p className='text-xl fw-bold ta-center mt-xs'>
      {Phrases.POPUP_GEN_FREE_AI_RESPONSE_TITLE}
    </p>
    <LinearLoader
      isLoading={isLoading}
      onSuccess={onClose}
      duration={GENERATION_DURATION}
      hasSnail
      color='primary'
      className='mb-xxs'
    />
    <TooltipFreePlan
      version={TooltipFreePlanVersion.V2}
      className={classNames(styles.tooltip, 'mr-auto ml-auto mb-md')}>
      <p className={classNames(styles.subtitle, 'text-sm ta-center')}>
        {Phrases.POPUP_GEN_FREE_AI_RESPONSE_SUBTITLE}
      </p>
    </TooltipFreePlan>
    <PremiumBenefits
      titleVersion={TitleVersion.V3}
      bordered
      ctaLabel={Phrases.PREMIUM_BENEFITS_CTA_LABEL}
      className='mb-xxxl'
    />
    <Rating />
  </Popup>
);

export default PopupGenFreeAIResponse;
